import React from 'react'
import {Route, Switch, withRouter, Redirect} from 'react-router-dom'
import Overview from './Overview'

const MamRoutes = ({match: {path}}) => (
  <Switch>
    <Redirect from={`${path}/transactions`} to="/transactions/history"/>
    <Route exact path={`${path}`} component={Overview} />
  </Switch>
)

export default withRouter(MamRoutes)
